import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { withSuspense } from '../../components/common/utils';
import GeneralMessages from '../../components/common/components/fieldbank/GeneralMessages';

class CommonErrorPage extends Component {

  render() {
    const { t } = this.props
    return <GeneralMessages
      id="id-error-message"
      titleTwo={`<h2>${t('errorMessages.titleTwo')}</h2>`}
      descriptionTwo={t('errorMessages.descTwo')}
      subTitle={`<h3>${t('errorMessages.subTitle')}</h3>`}
      titleLinkOne={`<h5>${t('errorMessages.titleLinkOne')}</h5>`}
      titleLinkTwo={`<h5>${t('errorMessages.titleLinkTwo')}</h5>`}
      titleLinkThree={`<h5>${t('errorMessages.titleLinkThree')}</h5>`}
      linkDescOne={t('errorMessages.linkDescOne')}
      linkDescTwo={t('errorMessages.linkDescTwo')}
      linkDescThree={t('errorMessages.linkDescThree')}
    />
  }
}

export default withSuspense()(withTranslation()(CommonErrorPage));